<div class="testTitle">
  <p>サービス申し込みテスト</p>
  <button id="ssn-test-lounge-application" class="testButton" (click)="serviceApplication(0)">ラウンジ申し込み</button>
  <button id="ssn-test-baggage-application" class="testButton" (click)="serviceApplication(1)">手荷物申し込み</button>
  <button id="ssn-test-meal-application" class="testButton" (click)="serviceApplication(2)">機内食申し込み</button>
</div>
